export const onNavigate = (callback: () => void): (() => void) => {
	const listeners: (() => void)[] = [];

	if (window.navigation && typeof window.navigation.addEventListener === 'function') {
		window.navigation.addEventListener('navigate', callback);
		listeners.push(() => window.navigation.removeEventListener('navigate', callback));
	} else {
		const onPop = () => callback();
		const onHash = () => callback();

		window.addEventListener('popstate', onPop);
		window.addEventListener('hashchange', onHash);

		listeners.push(() => window.removeEventListener('popstate', onPop));
		listeners.push(() => window.removeEventListener('hashchange', onHash));

		// Interception de pushState / replaceState
		const intercept = (type: 'pushState' | 'replaceState') => {
			const original = history[type];
			const patched = function (
				this: any,
				...args: [data: any, unused: string, url?: string | URL | null]
			) {
				original.apply(this, args);
				callback();
			};
			history[type] = patched;
			listeners.push(() => {
				history[type] = original;
			});
		};

		intercept('pushState');
		intercept('replaceState');
	}

	// Fonction de nettoyage
	return () => {
		listeners.forEach(remove => remove());
	};
};
